<template>
  <div class="columns is-multiline is-mobile">
    <div class="column">
      <window title="Knob dial: (more examples <a href='https://github.com/devstark-com/vue-circle-slider'
                                                  target='_blank'>here</a>)">
        <circle-slider v-model="sliderValue"></circle-slider>
        <circle-slider v-model="sliderValue" circle-color="#cecece"
        progress-color="#00f" knob-color="#5555ff"></circle-slider>
        <circle-slider v-model="sliderValue" circle-color="#f00"
        progress-color="#0a0" knob-color="#0c0"></circle-slider>
        <circle-slider v-model="sliderValue" circle-color="#edeff0"
        progress-color="#cecece" knob-color="#a0a0ff"></circle-slider>
        <circle-slider v-model="sliderValue" :circle-width="12"
        :progress-width="3" :knob-radius="4"></circle-slider>
        <circle-slider v-model="sliderValue" :circle-width="10"
        :progress-width="5" :knob-radius="10"></circle-slider>
        <circle-slider v-model="sliderValue" :circle-width="8"
        :progress-width="12" :knob-radius="10"></circle-slider>
      </window>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VueCircleSlider from 'vue-circle-slider';

Vue.use(VueCircleSlider);

export default {
  data() {
    return {
      sliderValue: 1,
    };
  },
  components: { VueCircleSlider },
};
</script>

<style scoped>
.window-block__body > div {
  display: inline-block;
  margin-right: 20px;
}
</style>
